module.exports = __webpack_public_path__ + "img/first2.835d0e3e.png";